import React from 'react';
import { Icon } from '@iconify/react';
import { useNavigate, useLocation } from 'react-router-dom';
import NotificationCenter from './NotificationCenter';
import { useAuth } from '../context/AuthContext';

const Header = ({ toggleSidebar, mobileMenuControl }) => {
    const navigate = useNavigate();
    const location = useLocation(); // Use location to check current path
    const { user } = useAuth();

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/');
    };

    // Check if on Assistant Dashboard
    const isAssistantDashboard = location.pathname.includes('/assistant-dashboard');

    return (
        <div className="navbar-header">
            <div className="row align-items-center justify-content-between">
                <div className="col-auto">
                    <div className="d-flex flex-wrap align-items-center gap-4">
                        <button type="button" className="sidebar-toggle-btn" onClick={toggleSidebar}>
                            <Icon icon="heroicons:bars-3" />
                        </button>
                        <button type="button" className="sidebar-mobile-toggle" onClick={mobileMenuControl}>
                            <Icon icon="heroicons:bars-3" />
                        </button>
                        <form className="navbar-search" onSubmit={(e) => e.preventDefault()} style={{ position: 'relative' }}>
                            {/* <Icon icon="ion:search-outline" className="icon" style={{ position: 'absolute', left: '15px', top: '50%', transform: 'translateY(-50%)', zIndex: 10, color: '#888' }} /> */}
                            <input type="text" name="search" placeholder="Search" className="form-control" style={{ paddingLeft: '45px' }} />
                        </form>
                    </div>
                </div>
                <div className="col-auto">
                    <div className="d-flex flex-wrap align-items-center gap-3">
                        {((user?.role === 'Assistant' && isAssistantDashboard) || user?.role === 'Doctor' || user?.role === 'Patient') && <NotificationCenter />}
                        <button className="btn btn-logout rounded-pill" onClick={handleLogout}>
                            <Icon icon="solar:logout-2-bold" /> Logout
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;
